import { styled } from "@mui/material/styles";
import { colors } from "../../styles";

export const LoginContainer = styled("div")(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
  },
}));

export const LoginNav = styled("div")(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flex: 2,
  background: "#fff",
}));

export const InnerNavContainer = styled("div")(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  width: "60%",
  [theme.breakpoints.down("laptop")]: {
    width: "80%",
  },
  margin: "120px auto 0",
  [theme.breakpoints.down("tablet")]: {
    marginTop: "32px",
  },
}));

export const LoginHeader = styled("h2")(`
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: ${colors.black};
    margin: 0px auto;
`);

export const LoginSubHeader = styled("p")(`
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #475467;
    margin: 0px auto;
`);

export const LoginButton = styled("button")(`
    width: 100%;
    height: 40px;
    margin: 30px auto 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: white;
    background: ${colors.black};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
    border-radius: 4px;
    border: 0;
    text-align: center;
    cursor: pointer;
    transition: 0.4s;
    &:hover{
        opacity: 0.7;
    }
`);

export const PlainButton = styled("button")(`
    width: 100%;
    margin: 4px auto;
    padding: 4px 0;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #475467;
    border-radius: 4px;
    border: 0;
    text-align: center;
    background: white;
    cursor: pointer;
    transition: 0.6s;
    &:hover{
        background: #f1f1f1;
    }
`);

export const LoginGradient = styled("div")(({ theme }) => ({
  height: "100vh",
  [theme.breakpoints.down("tablet")]: {
    height: "140px",
  },
  display: "flex",
  flex: 3,
  justifyContent: "center",
  background:
    "linear-gradient(90.06deg, #DBF2FC 0.06%, #E8E8FF 51.56%, #FFF4E3 99.94%)",
}));

export const LoginLogo = styled("img")(({ theme }) => ({
  display: "flex",
  width: "50%",
  [theme.breakpoints.down("tablet")]: {
    width: "90%",
    height: "120px",
  },
}));
